import v16Schema from "../client/schemaVersions/v16.js";
import v17Schema from "../client/schemaVersions/v17.js";
import { createMigration } from "@verdant-web/store";
import cuid from "cuid";
export default createMigration(v16Schema, v17Schema, async ({ queries, mutations }) => {
    // this migration is only to enforce some data shape for recipe document structure...
    // it changes all 'paragraph' top-level nodes to 'step' nodes in the document
    // and enforces each one has an id attr.
    const recipes = await queries.recipes.findAll();
    for (const recipe of recipes) {
        recipe.instructions = recipe.instructions || { type: "doc", content: [] };
        recipe.instructions.content = (recipe.instructions.content || [])
            .filter((c) => !!c)
            .map((step) => {
            var _a, _b;
            return (Object.assign(Object.assign({}, step), { type: "step", attrs: {
                    id: (_b = (_a = step.attrs) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : cuid(),
                } }));
        });
        await mutations.recipes.put(recipe);
    }
});
//# sourceMappingURL=v17.js.map